import { observable, action } from 'mobx'
import Api from '@api/yun_xuan/experienceShopApi'
import { message, Modal } from 'hljd'
import { hashHistory } from 'react-router'

class Store {
  @observable orderId = ''
  @observable detail = ''
  @action
  getDetail = async () => {
    let { data } = await Api.getDetailApi({ id: this.orderId })
    this.detail = data || {}
    this.exp_saler = data.exp_saler
  }
  @observable history = []
  @action
  getHistory = async () => {
    let {
      data: { list }
    } = await Api.getHistoryApi({ id: this.orderId })
    this.history = list || []
  }

  @observable message = ''
  @observable exp_saler = ''
  @observable isEdit = false
  @observable limit = 0
  @action
  changeField = type => e => {
    if (type === 'message') {
      this[type] = e.target.value.substring(0, 500)
    } else {
      this[type] = e.target.value
    }
  }
  @action
  editSaler = () => {
    this.isEdit = true
  }

  @action
  saveSaler = async () => {
    const { success } = await Api.editSalerApi({
      id: this.orderId,
      exp_saler: this.exp_saler
    })
    this.isEdit = false
    if (success) {
      this.getDetail()
    }
  }
  @action
  saveRemark = async () => {
    if (!this.message) return message.warn('备注不能为空')
    const { success } = await Api.editFollowupApi({
      id: this.orderId,
      message: this.message
    })
    if (success) {
      this.message = ''
      this.getHistory()
    }
  }

  @action
  comeMerchant = () => {
    const { is_come, status } = this.detail || {}
    if (is_come + '' === '0' && ['0', '2'].indexOf(status + '') <= -1) {
      Modal.confirm({
        title: '你是否确认“已到店”？',
        onOk: async () => {
          const { success } = await Api.comeMerchantApi({
            id: this.orderId,
            message: this.message
          })
          if (success) {
            this.getDetail()
            this.getHistory()
          }
        }
      })
    }
  }
  @action
  orderForm = () => {
    Modal.confirm({
      title: '你是否确认“已成单”？',
      onOk: async () => {
        const { success } = await Api.orderFormApi({
          id: this.orderId,
          message: this.message
        })
        if (success) {
          this.getDetail()
          this.getHistory()
        }
      }
    })
  }

  @action
  followFail = () => {
    Modal.confirm({
      title: '你是否确认“跟进失败”？',
      onOk: async () => {
        const { success } = await Api.followFailApi({
          id: this.orderId,
          message: this.message
        })
        if (success) {
          this.getDetail()
          this.getHistory()
        }
      }
    })
  }
  @action
  nevigateToCustomer = () => {
    const { merchant_customer_id } = this.detail
    hashHistory.push(
      `/localMerchant/newCustomer/detail/${merchant_customer_id}`
    )
  }
}

export default Store
